import { useState } from 'react';

import { useFunnel } from '../../hooks/use-analytics';
import { Select } from '../ui/select';
import { Skeleton } from '../ui/skeleton';

const STEPS = [
  { key: 'touched', label: 'Касание' },
  { key: 'replied', label: 'Ответ' },
  { key: 'qualified', label: 'Квалифицирован' },
  { key: 'meetingRequested', label: 'Встреча запрошена' },
  { key: 'meetingHeld', label: 'Встреча состоялась' },
] as const;

type GroupBy = 'channel' | 'agent' | 'scenario_version' | '';

function sumBuckets(buckets: { touched: number; replied: number; qualified: number; meetingRequested: number; meetingHeld: number }[]) {
  return STEPS.reduce<Record<string, number>>((acc, s) => {
    acc[s.key] = buckets.reduce((sum, b) => sum + b[s.key], 0);
    return acc;
  }, {});
}

export function FunnelWidget() {
  const [groupBy, setGroupBy] = useState<GroupBy>('');
  const { data, isLoading, isError } = useFunnel({ group_by: groupBy || undefined });

  if (isLoading) return <Skeleton className="h-56 w-full" />;
  if (isError) return <div className="text-sm text-red-600">Не удалось загрузить воронку.</div>;
  if (!data) return null;

  const totals = sumBuckets(data.buckets);
  const max = Math.max(1, totals.touched ?? 1);

  return (
    <div data-testid="funnel-widget" className="rounded border border-border p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-semibold">Воронка</h2>
        <Select aria-label="Разрез воронки" value={groupBy} onChange={(e) => setGroupBy(e.target.value as GroupBy)}>
          <option value="">Итого</option>
          <option value="channel">По каналу</option>
          <option value="agent">По агенту</option>
          <option value="scenario_version">По версии сценария</option>
        </Select>
      </div>
      <div className="space-y-2">
        {STEPS.map((s) => {
          const value = totals[s.key] ?? 0;
          const width = Math.round((value / max) * 100);
          return (
            <div key={s.key} data-testid={`funnel-step-${s.key}`}>
              <div className="mb-0.5 flex justify-between text-xs text-muted-fg">
                <span>{s.label}</span>
                <span>{value}</span>
              </div>
              <div className="h-3 rounded bg-muted">
                <div className="h-3 rounded bg-primary" style={{ width: `${width}%` }} />
              </div>
            </div>
          );
        })}
      </div>
      {groupBy && (
        <div className="mt-3 text-xs text-muted-fg">Разбито по {data.buckets.length} значению(ям) «{groupBy}»</div>
      )}
    </div>
  );
}
